import { cn } from "@/lib/cn";
import { formatHHMMSS } from "@/lib/formatTime";
import type { StaffRow, StaffTotals } from "@shared/types/staff";

interface StaffSectionProps {
  title: string;
  rows: StaffRow[] | undefined;
  totals: StaffTotals | undefined;
}

export function StaffSection({ title, rows, totals }: StaffSectionProps) {
  return (
    <div className="mx-auto pb-1 mb-1 w-[98%] text-center text-white">
      <h1 className="text-2xl">{title}</h1>
      <table className="mx-auto w-[98%] text-center border-collapse">
        <thead>
          <tr>
            <th className="font-light text-base border-b-2 border-white p-1 text-left">Name</th>
            <th className="font-light text-base border-b-2 border-white p-1">OnCall</th>
            <th className="font-light text-base border-b-2 border-white p-1">Prem Dials</th>
            <th className="font-light text-base border-b-2 border-white p-1">APP</th>
            <th className="font-light text-base border-b-2 border-white p-1">JR2</th>
            <th className="font-light text-base border-b-2 border-white p-1">TalkTime</th>
          </tr>
        </thead>
        <tbody>
          {(rows ?? []).map((row) => (
            <tr key={row.fullName}>
              <td className="text-sm p-1 text-left">{row.fullName}</td>
              <td className="p-1">
                <span
                  className={cn(
                    "inline-block w-3.5 h-3.5 bg-no-repeat bg-center bg-contain",
                    row.isOnCall
                      ? "bg-[url('/images/off-call.png')]"
                      : "bg-[url('/images/on-call.png')]",
                  )}
                  aria-label={row.isOnCall ? "off-call" : "on-call"}
                />
              </td>
              <td className="text-sm p-1">{row.canDialLeads ? row.osLeadDialCount : ""}</td>
              <td className="text-sm p-1">{row.appCount > 0 ? row.appCount : "0"}</td>
              <td className="text-sm p-1">{row.jr2Count > 0 ? row.jr2Count : "0"}</td>
              <td className="text-sm p-1">{formatHHMMSS(row.talkTime)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="border-t border-white">
            <td className="text-base p-1 text-left">Totals</td>
            <td className="text-base p-1">{totals?.count ?? 0}</td>
            <td />
            <td />
            <td />
            <td className="text-base p-1">{formatHHMMSS(totals?.talkTime ?? 0)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
